/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import TextField from '@material-ui/core/TextField';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import {
  checkQuarterValidation,
  compareQtrs,
  convertQuatreManufacturer,
} from '../../../../../SharedModules/CommonUtilities/commonUtilities';
import * as constantMessageData from '../../../../../SharedModules/Errors/constantMessageData';
import { handleErrorMessages, setNewCmsMatRowData } from '../../store/actions';
import { autoFormateDate } from '../../../../../SharedModules/utilities/utilities';
import { STRT_QTR_GREATER_THAN_3_ERR } from '../constantData';

export default (props) => {
  const dispatch = useDispatch();
  const resultData = useSelector(
    (state) => state.sharedState.CmsReducer.matDrugListFromStore
  );
  const errorMessagesFromRedux = useSelector((state) => {
    return state?.sharedState?.CmsReducer?.errorMessagesInRedux;
  });
  const { data, label, id, ariaLabel, isEnablebyRole } = props;
  const { colId } = props.column;
  let rowIndex = 0;
  if (resultData && resultData.length > 0) {
    rowIndex = resultData.findIndex((x) => {
      return x.id === data.id;
    });
  } // handing on change text boxes event
  const handleChange = (e) => {
    const newObj = [...resultData];
    props.node.setDataValue(colId, e.target.value);
    if (colId === 'startQtr') {
      newObj[rowIndex].startQtr = e.target.value;
    } else if (colId === 'endQtr') {
      newObj[rowIndex].endQtr = e.target.value;
    }
    newObj[rowIndex].addEdit = true;
    dispatch(setNewCmsMatRowData(newObj));
  };

  // handing on blur text boxes event
  const handleOnBlurEvent = (value) => {
    const val = autoFormateDate(value?.toUpperCase());
    const newObj = [...resultData];
    let localErr = errorMessagesFromRedux || [];
    if (!value && colId === 'startQtr') {
      localErr = localErr?.filter(
        (item) => item.fieldName !== `${colId}${rowIndex}`
      );
      newObj[rowIndex].startQtrErr = true;
      newObj[rowIndex].startQtr = '';
      localErr.push({
        fieldName: `${colId}${rowIndex}`,
        errorType: 'startQtrRequired',
        rowIndex: `${colId}${rowIndex}`,
        message: `${constantMessageData.START_QUARTER_ERROR} #${rowIndex + 1}.`,
      });
      dispatch(setNewCmsMatRowData(newObj));
    } else if (
      colId === 'startQtr' &&
      val &&
      convertQuatreManufacturer(val) &&
      Date.parse('07/01/2020') > Date.parse(convertQuatreManufacturer(val))
    ) {
      localErr = localErr?.filter(
        (item) => item.fieldName !== `${colId}${rowIndex}`
      );
      newObj[rowIndex].startQtrErr = true;
      newObj[rowIndex].startQtr = val;
      localErr.push({
        fieldName: `${colId}${rowIndex}`,
        errorType: 'startQtrGreater',
        rowIndex: `${colId}${rowIndex}`,
        message: `${STRT_QTR_GREATER_THAN_3_ERR} #${rowIndex + 1}.`,
      });
      props.node.setDataValue(colId, val);
      dispatch(setNewCmsMatRowData(newObj));
    } else if (val && !_.isEmpty(val) && !_.isNaN(val)) {
      if (checkQuarterValidation(val)) {
        localErr = localErr?.filter(
          (item) => item.fieldName !== `${colId}${rowIndex}`
        );
        props.node.setDataValue(colId, val);
        if (colId === 'startQtr') {
          newObj[rowIndex].startQtrErr = false;
        }
        if (colId === 'endQtr') {
          newObj[rowIndex].endQtrErr = false;
        }
        dispatch(setNewCmsMatRowData(newObj));
        if (
          props.data?.endQtr !== '' &&
          props.data?.endQtr !== undefined &&
          colId === 'startQtr'
        ) {
          if (
            compareQtrs(val, props.data?.endQtr) &&
            checkQuarterValidation(props.data?.endQtr)
          ) {
            localErr = localErr?.filter(
              (item) => item.fieldName !== `${colId}${rowIndex}`
            );
            props.node.setDataValue(colId, val);
            newObj[rowIndex].endQtrErr = true;
            dispatch(setNewCmsMatRowData(newObj));
            localErr.push({
              fieldName: `${colId}${rowIndex}`,
              errorType: 'rangeInvalid',
              rowIndex: `${colId}${rowIndex}`,
              message: `${constantMessageData.END_QTR_GRATER_START_QTR_ERR} #${
                rowIndex + 1
              }.`,
            });
          } else {
            localErr = localErr?.filter(
              (item) => item.fieldName !== `${colId}${rowIndex}`
            );
            const endQtrErr = localErr?.filter(
              (item) => item.fieldName === `endQtr${rowIndex}`
            );
            if (endQtrErr.length > 0) {
              newObj[rowIndex].endQtrErr = true;
            } else newObj[rowIndex].endQtrErr = false;
            dispatch(setNewCmsMatRowData(newObj));
          }
        } else if (props.data?.startQtr !== '' && colId === 'endQtr') {
          if (compareQtrs(props.data?.startQtr, value)) {
            localErr = localErr?.filter(
              (item) => item.fieldName !== `${colId}${rowIndex}`
            );
            props.node.setDataValue(colId, val);
            newObj[rowIndex].endQtrErr = true;
            dispatch(setNewCmsMatRowData(newObj));

            localErr.push({
              fieldName: `${colId}${rowIndex}`,
              errorType: 'rangeInvalid',
              rowIndex: `${colId}${rowIndex}`,
              message: `${constantMessageData.END_QTR_GRATER_START_QTR_ERR} #${
                rowIndex + 1
              }.`,
            });
          } else {
            localErr = localErr?.filter(
              (item) => item.fieldName !== `${colId}${rowIndex}`
            );
            newObj[rowIndex].endQtrErr = false;
            dispatch(setNewCmsMatRowData(newObj));
          }
        }
      } else {
        localErr = localErr?.filter(
          (item) => item.fieldName !== `${colId}${rowIndex}`
        );
        props.node.setDataValue(colId, val);
        if (colId === 'startQtr') {
          newObj[rowIndex].startQtrErr = true;
        }
        if (colId === 'endQtr') {
          newObj[rowIndex].endQtrErr = true;
        }
        dispatch(setNewCmsMatRowData(newObj));
        localErr.push({
          fieldName: `${colId}${rowIndex}`,
          errorType: 'invalidQuarterFormat',
          rowIndex: `${colId}${rowIndex}`,
          message:
            colId === 'startQtr'
              ? `${constantMessageData.CONTRACT_START_QUARTER_FORMAT_ERROR} #${
                props.node.rowIndex + 1
                }.`
              : `${constantMessageData.CONTRACT_END_QUARTER_FORMAT_ERROR} #${
                props.node.rowIndex + 1
                }.`,
        });
      }
    } else {
      if (colId === 'startQtr') {
        newObj[rowIndex].startQtrErr = false;
      }
      if (colId === 'endQtr') {
        newObj[rowIndex].endQtrErr = false;
      }
      localErr = localErr?.filter(
        (item) => item.fieldName !== `${colId}${rowIndex}`
      );
    }

    dispatch(handleErrorMessages([...new Set(localErr)]));
  };

  if (colId === 'endQtr') {
    return (
      <div data-testid="cms-text-box">
        <label className="m-0 visually-hidden" htmlFor={id}>
          <span>{label}</span>{' '}
        </label>
        <TextField
          id={id}
          fullWidth
          placeholder=""
          InputLabelProps={{
            shrink: true,
          }}
          inputProps={{ maxLength: 6, readOnly: isEnablebyRole }}
          value={data?.endQtr}
          onChange={(e) => handleChange(e)}
          onBlur={(e) => handleOnBlurEvent(e.target.value)}
          disabled={data?.disableEndQtr || false}
          className={
            resultData[rowIndex]?.endQtrErr
              ? 'td-active-cell tBill-validate frr-display-hidden-label'
              : 'frr-display-hidden-label'
          }
          aria-label={ariaLabel}
        />
      </div>
    );
  }
  if (colId === 'startQtr') {
    return (
      <div data-testid="cms-text-box">
        <label className="m-0 visually-hidden" htmlFor={id}>
          <span>{label}</span>{' '}
        </label>
        <TextField
          id={id}
          fullWidth
          placeholder=""
          InputLabelProps={{
            shrink: true,
          }}
          inputProps={{ maxLength: 6, readOnly: isEnablebyRole }}
          value={data?.startQtr}
          onChange={(e) => handleChange(e)}
          onBlur={(e) => handleOnBlurEvent(e.target.value)}
          disabled={data?.disableStartQtr || false}
          className={
            resultData[rowIndex]?.startQtrErr
              ? 'td-active-cell tBill-validate frr-display-hidden-label'
              : 'frr-display-hidden-label'
          }
          aria-label={ariaLabel}
        />
      </div>
    );
  }
};
